'use client';

import React, { PropsWithChildren } from 'react';
import { FrontBrandResponseDto } from '@/lib/jp-api/requests';

export const BrandContext = React.createContext<FrontBrandResponseDto>({} as FrontBrandResponseDto);

export type BrandProviderProps = PropsWithChildren & { brand: FrontBrandResponseDto };
export const BrandProvider: React.FC<BrandProviderProps> = (props) => {
  return <BrandContext.Provider value={props.brand}>{props.children}</BrandContext.Provider>;
};
